// extracted by mini-css-extract-plugin
export default {"sendMessageButton":"ProfilePage_sendMessageButton__+Feym"};